const actions = {
  // Page Memberships Actions
  GET_PAGE_MEMBERSHIPS: 'RBAC/PAGE_MEMBERSHIPS/GET_PAGE_MEMBERSHIPS',
  GET_PAGE_MEMBERSHIPS_SUCCESS: 'RBAC/PAGE_MEMBERSHIPS/GET_PAGE_MEMBERSHIPS_SUCCESS',
  GET_PAGE_MEMBERSHIPS_ERROR: 'RBAC/PAGE_MEMBERSHIPS/GET_PAGE_MEMBERSHIPS_ERROR',
  CREATE_PAGE_MEMBERSHIP: 'RBAC/PAGE_MEMBERSHIPS/CREATE_PAGE_MEMBERSHIP',
  CREATE_PAGE_MEMBERSHIP_SUCCESS: 'RBAC/PAGE_MEMBERSHIPS/CREATE_PAGE_MEMBERSHIP_SUCCESS',
  CREATE_PAGE_MEMBERSHIP_ERROR: 'RBAC/PAGE_MEMBERSHIPS/CREATE_PAGE_MEMBERSHIP_ERROR',
  UPDATE_PAGE_MEMBERSHIP: 'RBAC/PAGE_MEMBERSHIPS/UPDATE_PAGE_MEMBERSHIP',
  UPDATE_PAGE_MEMBERSHIP_SUCCESS: 'RBAC/PAGE_MEMBERSHIPS/UPDATE_PAGE_MEMBERSHIP_SUCCESS',
  UPDATE_PAGE_MEMBERSHIP_ERROR: 'RBAC/PAGE_MEMBERSHIPS/UPDATE_PAGE_MEMBERSHIP_ERROR',
  DELETE_PAGE_MEMBERSHIP: 'RBAC/PAGE_MEMBERSHIPS/DELETE_PAGE_MEMBERSHIP',
  DELETE_PAGE_MEMBERSHIP_SUCCESS: 'RBAC/PAGE_MEMBERSHIPS/DELETE_PAGE_MEMBERSHIP_SUCCESS',
  DELETE_PAGE_MEMBERSHIP_ERROR: 'RBAC/PAGE_MEMBERSHIPS/DELETE_PAGE_MEMBERSHIP_ERROR',
  CLEAR_PAGE_MEMBERSHIPS_ERROR: 'RBAC/PAGE_MEMBERSHIPS/CLEAR_PAGE_MEMBERSHIPS_ERROR',

  // Action Creators
  getPageMemberships: (options = {}) => ({
    type: actions.GET_PAGE_MEMBERSHIPS,
    options,
  }),
  getPageMembershipsSuccess: (pageMemberships, pagination) => ({
    type: actions.GET_PAGE_MEMBERSHIPS_SUCCESS,
    pageMemberships,
    pagination,
  }),
  getPageMembershipsError: (error) => ({
    type: actions.GET_PAGE_MEMBERSHIPS_ERROR,
    error,
  }),
  createPageMembership: (membershipData) => ({
    type: actions.CREATE_PAGE_MEMBERSHIP,
    membershipData,
  }),
  createPageMembershipSuccess: (pageMembership) => ({
    type: actions.CREATE_PAGE_MEMBERSHIP_SUCCESS,
    pageMembership,
  }),
  createPageMembershipError: (error) => ({
    type: actions.CREATE_PAGE_MEMBERSHIP_ERROR,
    error,
  }),
  updatePageMembership: (membershipId, membershipData) => ({
    type: actions.UPDATE_PAGE_MEMBERSHIP,
    membershipId,
    membershipData,
  }),
  updatePageMembershipSuccess: (pageMembership) => ({
    type: actions.UPDATE_PAGE_MEMBERSHIP_SUCCESS,
    pageMembership,
  }),
  updatePageMembershipError: (error) => ({
    type: actions.UPDATE_PAGE_MEMBERSHIP_ERROR,
    error,
  }),
  deletePageMembership: (membershipId) => ({
    type: actions.DELETE_PAGE_MEMBERSHIP,
    membershipId,
  }),
  deletePageMembershipSuccess: (membershipId) => ({
    type: actions.DELETE_PAGE_MEMBERSHIP_SUCCESS,
    membershipId,
  }),
  deletePageMembershipError: (error) => ({
    type: actions.DELETE_PAGE_MEMBERSHIP_ERROR,
    error,
  }),
  clearPageMembershipsError: () => ({
    type: actions.CLEAR_PAGE_MEMBERSHIPS_ERROR,
  }),
};

export default actions;
